module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_bluehole_m.799c6781fcae9369b9669015935df7bf.png";